<template>
  <div class="unorganizedGovernance" ref="unorganizedGovernance">
    <div class="left_part">
      <img src="./img/carIcon.png">
    </div>
    <div class="right_part">
      <div class="list_bg"></div>
      <div class="right_part_l" @click="goToPopup(1)">
        <div class="line l_line">
          <div class="line_type">洗车机</div>
          <div class="line_count_box">
            <count-to class="line_count number" :startVal="oldData.carWasherCount" :endVal="newData.carWasherCount" :duration="2000"></count-to>
            <span class="line_unit">台</span>
          </div>
        </div>
        <div class="line l_line">
          <div class="line_type">今日洗车</div>
          <div class="line_count_box">
            <count-to class="line_count number" :startVal="oldData.dayCount" :endVal="newData.dayCount" :duration="2000"></count-to>
            <span class="line_unit">次</span>
          </div>
        </div>
        <div class="line l_line">
          <div class="line_type">本周洗车</div>
          <div class="line_count_box">
            <count-to class="line_count number" :startVal="oldData.weekCount" :endVal="newData.weekCount" :duration="2000"></count-to>
            <span class="line_unit">次</span>
          </div>
        </div>
      </div>
      <div class="right_part_r" @click="goToPopup(2)">
        <div class="line r_line">
          <div class="line_type">清洁车</div>
          <div class="line_count_box">
            <count-to class="line_count number" :startVal="oldData.cleaningCountTotal" :endVal="newData.cleaningCountTotal" :duration="2000"></count-to>
            <span class="line_unit">辆</span>
          </div>
        </div>
        <div class="line r_line">
          <div class="line_type">今日调度</div>
          <div class="line_count_box">
            <count-to class="line_count number" :startVal="oldData.scheduleCountTotal" :endVal="newData.scheduleCountTotal" :duration="2000"></count-to>
            <span class="line_unit">次</span>
          </div>
        </div>
        <div class="line r_line">
          <div class="line_type">今日清扫</div>
          <div class="line_count_box">
            <count-to class="line_count number" :startVal="oldData.distanceTotal*1000" :endVal="newData.distanceTotal*1000" :duration="2000"></count-to>
            <span class="line_unit">米</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from "@/components/VueCountTo/vue-countTo.vue";
import { mapState, mapGetters } from "vuex";
import iframePup from "@/modules/iframePup/iframePup.vue";
import { getEncryptWithPassword } from '@/utils/cryptoUtil.js';


export default {
  components: { countTo },
  props: ["matrix", "x", "y"],
  data() {
    return {
      pageInfo: 'unorganizedGovernance.vue',
      computedName: '无组织治理控制组件',
      customerId: this.$store.state.customerId,
      setTime1: null,
      resData: {},
      distanceTotal: "",
      scheduleCountTotal: "",
      cleaningCountTotal: "",
      oldData: {
        carWasherCount: 0,
        dayCount: 0,
        weekCount: 0,
        distanceTotal: 0,
        scheduleCountTotal: 0,
        cleaningCountTotal: 0,
      },
      newData: {
        carWasherCount: 0,
        dayCount: 0,
        weekCount: 0,
        distanceTotal: 0,
        scheduleCountTotal: 0,
        cleaningCountTotal: 0,
      },
    };
  },
  computed: {
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
  },
  mounted() {
    let that = this;
    let w = $(that.$refs.unorganizedGovernance).outerWidth();
    let h = $(that.$refs.unorganizedGovernance).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getAllData();
  },
  unmounted() {
    if (this.setTime1) {
      clearTimeout(this.setTime1);
      this.setTime1 = null;
    }
  },
  methods: {
    getAllData() {
      if (this.setTime1) {
        clearTimeout(this.setTime1);
        this.setTime1 = null;
      }
      this.getData1();
      this.getData2();
      this.setTime1 = setTimeout(() => {
        this.getAllData();
      }, 1000 * 60);
    },
    async getData1() {
      this.resData = {};
      let data;
      let findCarWashCount = CONFIG.requestName + this.$apiOpt.findCarWashCount;
      data = await this.$apiUtils.get(findCarWashCount, {
        customerId: this.customerId,
      });
      if (data && (data.carWasherCount || data.dayCount || data.weekCount)) {
        this.oldData.carWasherCount = this.newData.carWasherCount;
        this.oldData.dayCount = this.newData.dayCount;
        this.oldData.weekCount = this.newData.weekCount;
        this.newData.carWasherCount = data.carWasherCount || 0;
        this.newData.dayCount = data.dayCount || 0;
        this.newData.weekCount = data.weekCount || 0;
      } else {
        if (this.setTime1) {
          clearTimeout(this.setTime1);
          this.setTime1 = null;
        }
        this.setTime1 = setTimeout(() => {
          this.getAllData();
        }, 1000 * 10);
      }
    },

    async getData2() {
      let summary = CONFIG.requestName + this.$apiOpt.summary;
      let res = await this.$apiUtils.get(summary, {
        customerId: this.customerId,
      });
      if (res) {
        let { distanceTotal, scheduleCountTotal, cleaningCountTotal } = res;
        this.oldData.distanceTotal = this.newData.distanceTotal;
        this.oldData.scheduleCountTotal = this.newData.scheduleCountTotal;
        this.oldData.cleaningCountTotal = this.newData.cleaningCountTotal;
        this.newData.distanceTotal = distanceTotal || 0;
        this.newData.scheduleCountTotal = scheduleCountTotal || 0;
        this.newData.cleaningCountTotal = cleaningCountTotal || 0;
      }
    },

    async goToPopup(id) {
      this.$store.commit("dialogStatus", true);
      if (id == 1) {
        this.$popup.open(iframePup, this.dialogCompontent, this, {
          dialog: `${window.bmeConfig.baseUrlHttp}/standard/${window.CONFIG.requestName}/page/noOrganizationEquipment/carWasher.html?customerId=${this.customerId}&sourceType=1&style=${this.curStyleTypeVal}` + (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : ''),
        });
      } else {
        this.$popup.open(iframePup, this.dialogCompontent, this, {
          dialog: `${window.bmeConfig.baseUrlHttp}/standard/${window.CONFIG.requestName}/page/noOrganizationEquipment/cleanCar.html?customerId=${this.customerId}&sourceType=1&style=${this.curStyleTypeVal}` + (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : ''),
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.unorganizedGovernance {
  height: 250px;
  width: 600px;

  display: flex;
  .left_part {
    width: 210px;
    margin-top: 20px;
    align-items: center;
    display: flex;
    img {
      width: 100%;
    }
  }
  .right_part {
    cursor: pointer;
    width: calc(100% - 210px);
    margin-top: 25px;
    position: relative;
    display: flex;
    justify-content: space-between;
    padding-top: 21px;
    padding-bottom: 23px;
    .line {
      width: 100%;
      height: 46px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 6px;
      .line_type {
        font-size: 16px;
        font-weight: 500;
        color: #e2effd;
        line-height: 22px;
        white-space: nowrap;
      }
      .line_count_box {
        white-space: nowrap;
        .line_count {
          font-size: 24px;
          font-weight: 400;
          color: #31ffae;
          line-height: 28px;
          margin-right: 5px;
        }
        .line_unit {
          @extend .line_type;
        }
      }
    }
    .list_bg {
      position: absolute;
      @include bg-box(381px, 184px, "list_bg.png");
      right: -5px;
      top: 0;
      z-index: -1;
    }
    .right_part_l {
      width: 50%;
    }
    .right_part_r {
      width: 50%;
    }
  }
}
</style>
